import { Typography } from "@material-ui/core";
import styled from "styled-components";

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
`;

export const SectionTitle = styled(Typography)`
  && {
    font-weight: 600;
    font-size: 16px;
    color: #333;
  }
`;

export const SectionHint = styled(Typography)`
  && {
    color: #777;
    font-size: 13px;
    margin-top: 2px;
  }
`;

export const TreeWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const TreePanel = styled.div`
  border: 1px solid #ececec;
  border-radius: 8px;
  background: #fafafa;
  padding: 8px 12px;
  max-height: 420px;
  overflow: auto;
`;

export const FolderBlock = styled.div`
  margin-bottom: 4px;
`;

export const NodeRow = styled.div`
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 0 4px;
  border-radius: 6px;
  cursor: ${({ $clickable }) => ($clickable ? "pointer" : "default")};
  user-select: none;

  &:hover {
    background: rgba(0, 0, 0, 0.03);
  }
`;

export const FolderLabel = styled(Typography)`
  && {
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }
`;

export const LeafRow = styled.div`
  display: flex;
  align-items: center;
  margin: 2px 0 2px 28px;
  padding: 2px 8px;
  border-radius: 6px;
  background: ${({ $checked, theme }) =>
    $checked ? theme.color.primary.light : "#fff"};
  border: 1px solid
    ${({ $checked, theme }) => ($checked ? theme.color.primary.main : "#eee")};
`;

export const LeafLabel = styled(Typography)`
  && {
    font-size: 13px;
    color: #444;
    line-height: 1.35;
  }
`;
